export const Articles = [
  {
    "name": "‘To look at your own child and know they are going to die is utterly indescribable’",
    "content": "Yavanna Keogh in one of a series of powerful blogs as she and her husband, Lar, watched cancer consume their son, Oscar.............",
    "link": "https://www.irishtimes.com/life-and-style/health-family/parenting/to-look-at-your-own-child-and-know-they-are-going-to-die-is-utterly-indescribable-1.4775477",
    "date": "18th Jan 2022",
    "provider": "Irish Times"
  },
  {
    "name": "Initiative will allow pets to visit sick children in hospital ",
    "content": "Work has begun on a unique project at Crumlin's Children's Hospital in Dublin that will see patients able to receive visits from their pet............",
    "link": "https://www.irishexaminer.com/news/arid-40782408.html",
    "date": "10th Jan 2022",
    "provider": "Irish Examiner"
  },

  {
    "name": "A four-year-old cancer survivor's simple wish ",
    "content": "Hazel Bass celebrated the end of her cancer treatment with a trip to Cork to fulfill her wish of staying in a nice hotel and eating fancy cakes...........",
    "link": "https://www.irishexaminer.com/news/munster/arid-40778256.html",
    "date": "4th Jan 2022",
    "provider": "Irish Examiner"
  },

  {
    "name": "HRB investment of €21 million in cancer clinical trials will transform cancer care in Ireland ",
    "content": "The funding will tackle childhood and adult cancers, making a real difference to the lives of cancer patient ...........",
    "link": "https://www.hrb.ie/news/news-story/article/hrb-investment-of-e21-million-in-cancer-clinical-trials-will-transform-cancer-care-in-ireland/",
    "date": "16th December 2020",
    "provider": "hrb.ie"
  },
  {
    "name": "Childhood cancer diagnosis costs families €15,000, says Irish Cancer Society ",
    "content": "A childhood cancer diagnosis can hit family incomes on average by €15,300 annually on top of other crippling expenses ...........",
    "link": "https://www.irishexaminer.com/news/arid-40733589.html",
    "date": "1st November 2021",
    "provider": "Irish Examiner"
  },
  {
    "name": "Barretstown: What Paul Newman did for Saoirse, Kitty, Julie and Isaac ",
    "content": "The Co Kildare camp was set up by a man who ‘wanted to help kids who were sick feel a bit normal’ ...........",
    "link": "https://www.irishtimes.com/life-and-style/barretstown-what-paul-newman-did-for-saoirse-kitty-julie-and-isaac-1.4688899",
    "date": "30th October 2021",
    "provider": "Irish Times"
  },
  {
    "name": "Scientists use AI to help discover new treatment for deadly childhood cancer",
    "content": "Scientists have used artificial intelligence (AI) to create a drug regime for children with a type of deadly brain cancer ...........",
    "link": "https://www.irishexaminer.com/world/arid-40705094.html",
    "date": "23 September 2021",
    "provider": "Irish Examiner"
  },
  {
    "name": "‘Worth the wait’: The families getting help from the Cancer Fund for Children",
    "content": "Belfast-based organisation hopes to roll out its services across all of Ireland’s 32 counties ...........",
    "link": "https://www.irishtimes.com/life-and-style/health-family/parenting/worth-the-wait-the-families-getting-help-from-the-cancer-fund-for-children-1.4568586",
    "date": "26 May 2021",
    "provider": "Irish times"
  },
  {
    "name": "Family’s Atlantic Crossings Are Life Givers",
    "content": "An Irish family flew to New York to make sure that their three-year-old daughter did not suffer a cancer relapse.........",
    "link": "https://www.irishecho.com/2021/04/familys-atlantic-crossings-are-life-givers/",
    "date": "20th April 2021",
    "provider": "Irish Echo"
  },
  {
    "name": "Daffodil Day raises €6m for Irish Cancer Society services",
    "content": "An incredible €6m raised on the ‘most important Daffodil Day ever’ will fund vital services for cancer patients.........",
    "link": "https://www.meathchronicle.ie/2021/03/30/daffodil-day-raises-e6m-for-irish-cancer-society-services/",
    "date": "31st March 2021",
    "provider": "Meath Chronicle"
  },
  {
    "name": "'Daisy Lodge brings us together as a family '",
    "content": "Daisy Hill Lodge in Co Down has been a haven for Dublin girl April Banks and her family as she has battled neuroblastoma as a baby and a stroke in 2019. ...........",
    "link": "https://www.independent.ie/life/health-wellbeing/daisy-lodge-brings-us-together-as-a-family-it-isa-lovely-break-away-from-the-reality-of-childhoodcancer-40248844.html",
    "date": "29th March 2021",
    "provider": "Independent.ie"
  },
  {
    "name": "Outpouring of support for 'brave' Sarah Harding as she says she's got 'months' left",
    "content": "Girls Aloud singer Sarah Harding shared details of her diagnosis and treatment in full for the first time, devastating fans...........",
    "link": "https://www.irishmirror.ie/showbiz/celebrity-news/outpouring-support-brave-sarah-harding-23707168",
    "date": "13 March 2021",
    "provider": "Irish Mirror"
  },
  {
    "name": "Trial for Children with Neuroblastoma Funded by Parent-Led Charities",
    "content": "In a landmark in paediatric oncology research, children with high-risk neuroblastoma across Europe and North America will be treated together for the first time...........",
    "link": "https://www.solvingkidscancer.org.uk/landmark-trans-atlantic-trial-for-children-with-high-risk-neuroblastoma",
    "date": "Feb 2021",
    "provider": "www.solvingkidscancer.org.uk"
  },
  {
    "name": "Equal access to financial services needed for cancer survivors",
    "content": "MANY cancer survivors face discrimination when accessing financial services such as mortgages and insurances...........",
    "link": "https://www.echolive.ie/business/arid-40231352.html",
    "date": "22 Feb 2021",
    "provider": "Echo Live"
  },
  {
    "name": "Parents 'exploited' by overseas cancer treatments",
    "content": "Consultant Prof Owen Smith and oncologist Dr Michael Capra of Our Lady’s Hospital in Crumlin, Dublin, said they fear parents of seriously sick children are being “exploited”...........",
    "link": "https://www.irishtimes.com/news/health/parents-exploited-by-overseas-youth-cancer-treatments-1.1900886",
    "date": "16th Jan 2021",
    "provider": "Irish Times"
  },
  {
    "name": "Department of Health can't give timeline for rollout of publicly-funded IVF",
    "content": "Paul Gordan of the Irish Cancer Society said that “we don’t want to see people who can’t afford IVF not having access to a treatment that is available in most European countries..........",
    "link": "https://www.thejournal.ie/no-timeline-for-ivf-funding-5302561-Jan2021/",
    "date": "4th January 2021",
    "provider": "The Journal"
  },
  {
    "name": "Helping children – and adults – to explore and understand grief",
    "content": "Stephen Teap would have happily not put up a single decoration for the first Christmas without his wife Irene, but he knew he had to “keep the show on the road”........",
    "link": "https://www.irishtimes.com/life-and-style/health-family/parenting/helping-children-and-adults-to-explore-and-understand-grief-1.4429912",
    "date": "16th December 2020",
    "provider": "Irish Times"
  },
  {
    "name": "Cloud doodles help charities after artist's daughter diagnosed with leukemia",
    "content": "A Dublin-based artist is using his cloud doodle project to give back to charities who have helped his family through a difficult year...........",
    "link": "https://www.rte.ie/news/2020/1121/1179622-cloud-doodle-charity/",
    "date": "23rd November 2020",
    "provider": "rte.ie"
  },
  {
    "name": "Cork GAA club praised for their 'monumental efforts' after raising almost €94k for charity",
    "content": "Earlier this week, Aoibheann's Pink Tie took to social media to thank Aghabullogue GAA and everyone else who participated in or donated to the fundraiser..........",
    "link": "https://www.echolive.ie/corknews/Cork-GAA-club-praised-for-their-monumental-efforts-after-raising-almost-94k-for-childrens-cancer-charity-71d973ab-6e14-4f9c-bb49-44c71e49e520-ds",
    "date": "5th November 2020",
    "provider": "echo live"
  },
  {
    "name": "Stars support campaign for Wexford tot Fiadh O’Connor who is battling rare childhood cancer",
    "content": "THE family of a little girl diagnosed with a rare and aggressive form of cancer are on a mission to raise €375k.........",
    "link": "https://www.thesun.ie/tvandshowbiz/6066718/amy-huberman-fiadh-oconnor-cancer-treatment-neuroblastoma/",
    "date": " 27th October 2020",
    "provider": "The Sun"
  },
  {
    "name": "Watch: Christine Lampard talks about childhood cancer and her worst fears",
    "content": "She chatted to four mums during Childhood Cancer Awareness Month who have been supported by CLIC Sargent.........",
    "link": "https://www.belfastlive.co.uk/whats-on/be/watch-christine-lampard-talks-childhood-19074313",
    "date": "27th October 2020",
    "provider": "Belfact live"
  },
  {
    "name": "New children's rooms a big help at hospital",
    "content": "Ciara Galvin speaks to those involved in providing three state-of-the-art rooms at SUH's paediatric ward.........",
    "link": "https://www.independent.ie/regionals/sligochampion/news/new-childrens-rooms-a-big-help-at-hospital-39643136.html",
    "date": "24th October 2020",
    "provider": "Independent.ie"
  },
  {
    "name": "Ryan Tubridy left moved by story of fund raising for child cancer charity",
    "content": "The Dubliner was clearly touched by the tale of Amelia, Tessa, Emma-Jane and Megan, four eight-year-olds who set out on a readathon to raise money for the Gavin Glynn Foundation.........",
    "link": "https://www.irishmirror.ie/showbiz/irish-showbiz/ryan-tubridy-left-moved-story-22888327",
    "date": " 22 Oct 2020",
    "provider": "Irish Mirror"
  },
  {
    "name": "Parents who lost son to cancer donate fleet of mini garda cars",
    "content": "A couple who lost one of their twin boys to cancer shortly before he turned two have channelled their grief into fundraising for a fleet of toy garda cars.........",
    "link": "https://www.irishexaminer.com/news/munster/arid-40058495.html",
    "date": "2nd Oct 2020",
    "provider": "Irish Examiner"
  },
  {
    "name": "Trinity cancer research discovery leads to clinical",
    "content": "A discovery by Trinity College researchers in a form of cancer common in children, has led to the announcement that C4 Therapeutics plan to begin clinical trials in 2021.........",
    "link": "https://www.eurekalert.org/pub_releases/2020-09/tcd-tcr092820.php",
    "date": "28th September 2020",
    "provider": "eureka"
  },
  {
    "name": "Suffolk boy with rare cancer ready for first day at school",
    "content": "A boy who doctors feared would not survive when he was diagnosed with a rare childhood cancer aged four months is due to start school..........",
    "link": "https://www.bbc.com/news/uk-england-suffolk-54239800",
    "date": "21st September 2020",
    "provider": "BBC news"
  },
  {
    "name": "Child cancer room opened at Lourdes",
    "content": "Thanks to the joint efforts of Drogheda Rotary Club and The Childhood Cancer Foundation, the first little patients are now using the dedicated paediatric oncology room.........",
    "link": "https://www.independent.ie/regionals/droghedaindependent/news/child-cancer-room-opened-at-lourdes-39510384.html",
    "date": "12th September 2020",
    "provider": "Independent.ie"
  },
  {
    "name": "Irish Cancer Society - Marathon in a month",
    "content": "The marathon EVERYONE can complete! You can walk, run or jog it, at your own speed and in your own time, but the main thing is you CAN do it, you CAN complete a marathon!.........",
    "link": "https://marathoninamonth.cancer.ie/",
    "date": "11th September 2020",
    "provider": "Irish Cancer Society"
  },
  {
    "name": "Sophie (5) lit up a room and was a little inspiration",
    "content": "Sophie Walsh, who left this world on Tuesday (18th) aged five, was a ray of sunshine who brightened up the lives of everyone.........",
    "link": "https://www.independent.ie/regionals/newrossstandard/sophie-5-lit-up-a-room-and-was-a-little-inspiration-39474814.html",
    "date": "29 August 2020",
    "provider": "Independent.ie"
  },
  {
    "name": "Sheridan Smith's tragic childhood trauma after older brother died from cancer",
    "content": "Sheridan Smith grew teary eyed as she detailed her brother's battle with cancer on her new documentary..........",
    "link": "https://www.irishmirror.ie/tv/sheridan-smiths-tragic-childhood-trauma-22614248",
    "date": "1st September 2020",
    "provider": "Irish Mirror"
  },
  {
    "name": "Chadwick Boseman helped children with cancer while keeping own diagnosis private",
    "content": "Chadwick Boseman kept his cancer diagnosis private while “bringing joy and courage” to children with the disease..........",
    "link": "https://www.irishexaminer.com/lifestyle/celebrity/arid-40039847.html",
    "date": " August 29th 2020",
    "provider": "Irish Examiner"
  },
  {
    "name": "Family plant cherry tree in memory of heroic Robyn",
    "content": "A cherry tree has been planted in memory of a Dublin teenager who battled a rare cancer for most of her life. Robyn Smyth, who suffered from neuroblastoma, captured the hearts of the nation...........",
    "link": "https://www.herald.ie/news/family-plant-cherry-tree-in-memory-of-heroic-robyn-39471916.html",
    "date": "24th August 2020",
    "provider": "The Herald"
  },
  {
    "name": "Evidence for hypoxia increasing the tempo of evolution in glioblastoma",
    "content": "Our results suggest that hypoxia could be a crucible that effectively warps evolutionary velocity, making key mutations more likely. ...........",
    "link": "https://www.nature.com/articles/s41416-020-1021-5",
    "date": "27th August 2020",
    "provider": "nature.com (BJC)"
  },
  {
    "name": "Initiative created to protect the fertility of children",
    "content": "Every year in Ireland, more than 200 children are diagnosed with cancer, and the necessary treatment they are subscribed can often end up damaging their fertility........",
    "link": "https://www.herfamily.ie/wellness/new-initiative-created-protect-future-fertility-children-young-people-treated-cancer-379633",
    "date": "20th August 2020",
    "provider": "herfamily.ie"
  },
  {
    "name": "September is Childhood Cancer Awareness Month ",
    "content": "Sadly, every week in the UK, two families are told that their child has neuroblastoma, a rare and life-threatening cancer. Lets work together to drive awareness of childhood cancer........",
    "link": "https://www.neuroblastoma.org.uk/childhood-cancer-awareness-month?gclid=CjwKCAjw1ej5BRBhEiwAfHyh1GjOgykHqHVLMbBgItn4R3RsEPbWCfATT1dFhec5GjM9-JW_KLpnchoCM0sQAvD_BwE",
    "date": "17th August 2020",
    "provider": "neuroblastoma.org.uk"
  }
]

